<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <v-badge
        v-for="tab in tabs"
        :key="tab.page"
        :value="tab.hoverBtn"
        color="deep-purple accent-4"
        :content="tab.hoverBtnStr"
        bottom
        right
        transition="slide-x-transition"
      >
      <v-hover v-model="tab.hoverBtn">
      <v-btn
        text
        icon
        @click="$router.push({ name: tab.page })"
      >{{ tab.name }}
       <v-icon>{{ tab.icon }}</v-icon>
       <v-spacer />
       </v-btn>
       </v-hover>
      </v-badge>
      <v-spacer></v-spacer> 
      <v-spacer></v-spacer> 
      <v-spacer></v-spacer> 
      <v-img v-if="notOnHomePage"
        contain
        height="50"
        src="@/assets/Wasatch.png"
        style="display: inline-block;"
      />
      <div v-if="selectCounty">
        <v-toolbar  max-height="58px" >
          <v-autocomplete
            auto-select-first
            cache-items
            compact
            dense
            :items="counties" 
            hint="Select County" 
            persistent-hint
            item-text="county"
            item-value="ID"
            v-model="selectedCounty" 
            @change="changeCounty"
            return-object
          > </v-autocomplete>
        </v-toolbar>
      </div>
      <div v-else-if="notOnHomePage"   style="display: inline-block;">
        {{ selectedCounty.county }} County
      </div>
      <v-spacer></v-spacer> 
      <v-badge
        :value="hoverSign"
        color="deep-purple accent-4"
        :content="hoverSignStr"
        bottom
        left
        transition="slide-x-transition"
      >
        <v-hover v-model="hoverSign">
          <v-btn 
            text @click="updateAuth"
            icon
          >
            <v-icon
            color="grey lighten-1"
            >   
            mdi-account
            </v-icon>
            <v-spacer />
          </v-btn>
        </v-hover>
      </v-badge>
    </v-app-bar>
    <v-main>
      <v-snackbar v-model="snackbar" multi-line top :timeout="7500">
        {{ snackbarText }}
        <template v-slot:actions>
        <v-btn
          dark
          color="red"
          varient="text"
          @click="snackbar = false"
        >Close</v-btn>
        </template>
      </v-snackbar>
      <v-dialog v-model="signInDialog" max-width="500px" persistent>
        <v-card>
          <v-card-title class="text-h5">Account Sign In</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col >
                  <v-text-field
                    label="Email address"
                    prepend-inner-icon="mdi-email-outline"
                    single-line
                    outlined
                    solo-inverted
                    v-model="email"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :disabled="signInDisabled" @click="sendEmail">Send Link</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-container>
      <router-view />
      </v-container>
    </v-main>
    <v-footer >
      <v-row justify="center" no-gutters>
        <span class="mdi mdi-copyright"></span>{{ new Date().getFullYear() }} — <strong>AJoules, Inc.</strong>
      </v-row>
    </v-footer>      
  </v-app>
</template>

<script>
//import User from './classes/User.js';
import deviceUser from './deviceUser.js'

export default {
  name: "CoinsUt",
  mixins: [deviceUser],
  computed: {
    signInDialog: {
      get() {
           return !this.$store.getters.userSignedIn;
      },
      set() {
           this.$store.dispatch("signInAction");
      },

    },
    signInDisabled() {
      return this.email.length < 8 ;
    },
    hoverSignStr () {
       return !this.signInDialog ? "Sign Out"  : "Sign In" 
    },
    notOnHomePage () {
      return (this.$route.path != "/")
    }
  },
  data: () => ({
    selectCounty: false,
    counties: [
      { county: "Beaver", ID: "beav"},
      { county: "Carbon", ID: "carb"},
      //{ county: "Daggett", ID: "dagg"},
      //{ county: "Duchesne", ID: "duch"},
      //{ county: "Emery", ID: "emer" },
      { county: "Garfield", ID: "garf"},
      { county: "Grand", ID: "gran"},
      { county: "Morgan", ID: "morg"},
      { county: "Piute", ID: "piu"},
      { county: "San Juan", ID: "juan"},
      { county: "Wayne", ID: "wayn"},
      { county: "Wasatch", ID: "was" }
    ],
    selectedCounty: {},
    hoverSign: false,
    email:"",
    snackbar: false,
    snackbarText: "",
    tabs: [
      { name: "", page: "/" , icon: "mdi-menu", 
        hoverBtn: false, hoverBtnStr: "Home"},
      { name: "UPP", page: "UPP" , icon: "mdi-pencil", 
        hoverBtn: false, hoverBtnStr: "Edit and submit (Unattached Personal Property) value records."}
    ],
    //countyDialog: false
  }),
  methods: {
    changeCounty() {
      this.$store.dispatch("commitCounty", this.selectedCounty);
      if (this.$route.path != "/") {
        //console.log("1 router push /")
        this.$router.replace("/");
      } //else console.log("avoided 1 router push /")
    },
    upp() {
      if (this.$route.path != "/upp") {
          this.$router.push("UPP")
      } //else console.log("avoided router push /")
    },
    sendEmail() {
        this.sendOneTimeEmailVerification()
        this.snackbarText =
          "We sent a verification code to your email " + this.email +
          " ...make sure to verify your email by (clicking on the link," +
          " or copying and pasting the link in the URL address bar of your " +
          " browser above) to automatically link your account.";
        this.snackbar = true;
    },
    updateAuth() {
      if (!this.signInDialog) {
        this.$store.getters.fb.auth()
          .signOut()
          .then(() => {
            this.$store.dispatch("signOutAction");
            this.snackbarText = "Sign out successfull!";
            this.snackbar = true;
            if (this.$route.path != "/") {
              //console.log("1 router push /")
              this.$router.push("/");
            } //else console.log("avoided 1 router push /")
          });
      } else {
        this.$store.dispatch("signInAction")
      }
    },
  },
  created() {
    //let user = new User(true);
    //this.$store.dispatch("commitUser", user);
    this.checkSignInWithEmailLink() // quietly
    let user = this.$store.getters.user;
    this.selectedCounty = this.$store.getters.county;
    if (user.emailVerified) {
      this.snackbarText =
          "Sign in " + user.email + " successfull!";
      this.snackbar = true;
      if (this.$route.path != "/") {
        //console.log("2 router push /")
        this.$router.push("/");
      } //else console.log("avoided 2 router push /")
    } else  {
      if (user.email > 7) {
        this.email = user.email
      }
    }
  }
};
</script>
